export const availableEnvironments = ['local', 'test', 'staging', 'production'] as const;

export function getEnv(name: string): string | null {
    return (
        (import.meta.env?.[`VITE_${name}`] as string | undefined) ??
        process.env[`VITE_${name}`] ??
        null
    );
}

export function getEnvRequired(name: string): string {
    const value = getEnv(name);
    if (!value) {
        throw new Error('The following environment variable ' + name + ' is not defined');
    }
    return value;
}
